function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgFlagTr = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 32",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "#be1e2d",
    d: "M0 32h40V0H0z"
  }), ___EmotionJSX("path", {
    fill: "#fff",
    d: "M19.187 14.589l.298-1.789 1.186 1.367 1.729-.219-.853 1.57.771 1.654-1.714-.397-1.253 1.241-.205-1.815-1.547-.887z"
  }), ___EmotionJSX("path", {
    fill: "#fff",
    d: "M17.816 9.76a6.635 6.635 0 00-2.333-.42c-3.687 0-6.677 2.998-6.677 6.697s2.989 6.697 6.677 6.697c.821 0 1.607-.149 2.333-.42a7.965 7.965 0 01-5.004 1.76c-4.425 0-8.012-3.598-8.012-8.036s3.587-8.036 8.012-8.036c1.893 0 3.633.659 5.004 1.76z"
  }), ___EmotionJSX("path", {
    fill: "#2d2926",
    opacity: 0.15,
    d: "M38 30H2V2h36v28zm2-30H0v32h40V0z"
  }));
});
export default SvgFlagTr;